import { Command, Option } from "clipanion";
import { M8tCommand } from "../../lib/m8t-command.js";
import { resetConfig } from "../../lib/config.js";
import { renderJson, resolveOutputMode } from "../../lib/output.js";

export class ConfigResetCommand extends M8tCommand {
  static paths = [["config", "reset"]];
  static usage = Command.Usage({
    description: "Clear the cached gateway URL — re-discover on next command.",
  });

  output = Option.String("--output");

  async executeCommand(): Promise<number> {
    const mode = resolveOutputMode(
      this.output as "pretty" | "json" | "auto" | undefined,
      this.context.stdout as NodeJS.WriteStream,
    );
    const deleted = await resetConfig();
    if (mode === "json") {
      this.context.stdout.write(renderJson({ deleted }) + "\n");
      return 0;
    }
    if (deleted) {
      this.context.stdout.write("config cleared.\n");
    } else {
      this.context.stdout.write("no config to clear.\n");
    }
    return 0;
  }
}
